// extracted by mini-css-extract-plugin
export default {"appContainer":"AuthLayout_appContainer__HWZ6x","main":"AuthLayout_main__i39zA"};